import React from 'react';
import { ToastProvider } from '../ToastContext';
import { ConfirmationDialogProvider } from '../ConfirmationDialog';
import TinyBaseProvider from '@/context/TinyBaseProvider/TinyBaseProvider';
import { Outlet } from 'react-router';
import ZopimChat from '@/components/ZopimChat';
import HypertrackerThemeProvider from '@/context/HypertrackerThemeProvider/HypertrackerThemeProvider';

/**
 * @name HyperTrackerGlobalContext
 * @description Wrapper component for all global context providers except MUI and Error Boundary
 * @param children
 * @constructor
 */
const HyperTrackerGlobalContext: React.FC<unknown> = () => {
    return (
        <HypertrackerThemeProvider>
            <TinyBaseProvider>
                <ConfirmationDialogProvider>
                    <ToastProvider>
                        <ZopimChat />
                        <Outlet />
                    </ToastProvider>
                </ConfirmationDialogProvider>
            </TinyBaseProvider>
        </HypertrackerThemeProvider>
    );
};

export default HyperTrackerGlobalContext;
